import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import IconDimensions from 'components/icons/IconDimensions';
import { colorGrayLight2 } from 'styles/layout/colors';
import { BUILD_YOUR_OWN_SOFA_LINK } from 'commons/constants';
import PDPDesktopHeroThumbnail from '../PDPDesktopHeroThumbnail';
import IconFourSquare from '../../../../icons/iconFourSquare';
const DEFAULT_DIMENSION_SHOT_URLS = [];
const DEFAULT_PHOTOS = [];
const PDPDesktopConfigThumbnails = t0 => {
  const $ = _c(27);
  const {
    dimensionsImage,
    shouldShowDimensionThumbnail: t1,
    dimensionShotUrls: t2,
    enableCrops,
    isConfigFlipped: t3,
    isCylindoConfigurationPhotos: t4,
    loading: t5,
    pdpIsModularBYOProduct: t6,
    photos: t7,
    selectedPhoto: t8,
    setSelectedPhoto,
    viewGalleryImageEvent
  } = t0;
  const shouldShowDimensionThumbnail = t1 === undefined ? false : t1;
  const dimensionShotUrls = t2 === undefined ? DEFAULT_DIMENSION_SHOT_URLS : t2;
  const isConfigFlipped = t3 === undefined ? false : t3;
  const isCylindoConfigurationPhotos = t4 === undefined ? false : t4;
  const loading = t5 === undefined ? false : t5;
  const pdpIsModularBYOProduct = t6 === undefined ? false : t6;
  const photos = t7 === undefined ? DEFAULT_PHOTOS : t7;
  const selectedPhoto = t8 === undefined ? null : t8;
  if (loading) {
    let t9;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t9 = <div className="flex">{[0, 1, 2, 3, 4].map(_temp)}</div>;
      $[0] = t9;
    } else {
      t9 = $[0];
    }
    return t9;
  }
  const showDimensionThumbnail = shouldShowDimensionThumbnail ?? (!!dimensionsImage || dimensionShotUrls.length > 0);
  const numOfPhotosToShow = showDimensionThumbnail ? 5 : 6;
  let t10;
  let t9;
  if ($[1] !== enableCrops || $[2] !== isConfigFlipped || $[3] !== isCylindoConfigurationPhotos || $[4] !== numOfPhotosToShow || $[5] !== pdpIsModularBYOProduct || $[6] !== photos || $[7] !== selectedPhoto || $[8] !== setSelectedPhoto || $[9] !== viewGalleryImageEvent) {
    const photosToShow = photos.slice(0, numOfPhotosToShow);
    t9 = "flex";
    t10 = photosToShow.map((t11, index) => {
      const {
        id,
        src,
        cropData,
        type
      } = t11;
      return <PDPDesktopHeroThumbnail cropData={cropData} enableCrops={enableCrops} key={id} onClick={() => {
        setSelectedPhoto?.({
          type,
          id,
          index,
          src
        });
      }} onMouseEnter={() => {
        setSelectedPhoto?.({
          type,
          id,
          index,
          src
        });
        viewGalleryImageEvent({
          imageLocation: "Configuration Gallery",
          imageFilename: src?.split("/").pop() || "",
          position: index,
          totalImages: photos.length
        });
      }} onLoadFailure={() => {
        if (pdpIsModularBYOProduct && selectedPhoto === id) {
          let newType = "configuration";
          let newIndex = 0;
          if (index === 0) {
            if (photosToShow.length > 1) {
              newIndex = 1;
            } else {
              newType = "studio";
            }
          }
          setSelectedPhoto?.({
            type: newType,
            index: newIndex
          });
        }
      }} type="configuration" src={src} isSelected={pdpIsModularBYOProduct ? selectedPhoto === id : selectedPhoto === src} isConfigFlipped={isConfigFlipped} isCylindoPhoto={isCylindoConfigurationPhotos} />;
    });
    $[1] = enableCrops;
    $[2] = isConfigFlipped;
    $[3] = isCylindoConfigurationPhotos;
    $[4] = numOfPhotosToShow;
    $[5] = pdpIsModularBYOProduct;
    $[6] = photos;
    $[7] = selectedPhoto;
    $[8] = setSelectedPhoto;
    $[9] = viewGalleryImageEvent;
    $[10] = t10;
    $[11] = t9;
  } else {
    t10 = $[10];
    t9 = $[11];
  }
  let t11;
  if ($[12] !== pdpIsModularBYOProduct || $[13] !== selectedPhoto || $[14] !== setSelectedPhoto) {
    t11 = pdpIsModularBYOProduct ? <PDPDesktopHeroThumbnail enableCrops={false} key="build-your-own" onClick={() => {
      setSelectedPhoto?.({
        type: "buildyourown",
        index: 0
      });
    }} onMouseEnter={() => {
      setSelectedPhoto?.({
        type: "buildyourown",
        index: 0
      });
    }} type="buildyourown" icon={<IconFourSquare />} isSelected={selectedPhoto === BUILD_YOUR_OWN_SOFA_LINK} /> : null;
    $[12] = pdpIsModularBYOProduct;
    $[13] = selectedPhoto;
    $[14] = setSelectedPhoto;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== dimensionsImage || $[17] !== isConfigFlipped || $[18] !== selectedPhoto?.type || $[19] !== setSelectedPhoto || $[20] !== showDimensionThumbnail) {
    t12 = showDimensionThumbnail && <PDPDesktopHeroThumbnail key={dimensionsImage || "dimensions"} onClick={() => {
      setSelectedPhoto?.({
        type: "dimensional",
        index: 0
      });
    }} onMouseEnter={() => {
      setSelectedPhoto?.({
        type: "dimensional",
        index: 0
      });
    }} isSelected={selectedPhoto?.type === "dimensional"} icon={<IconDimensions width={24} height={24} color={colorGrayLight2} />} isConfigFlipped={isConfigFlipped} />;
    $[16] = dimensionsImage;
    $[17] = isConfigFlipped;
    $[18] = selectedPhoto?.type;
    $[19] = setSelectedPhoto;
    $[20] = showDimensionThumbnail;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== t10 || $[23] !== t11 || $[24] !== t12 || $[25] !== t9) {
    t13 = <div className={t9}>{t10}{t11}{t12}</div>;
    $[22] = t10;
    $[23] = t11;
    $[24] = t12;
    $[25] = t9;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  return t13;
};
PDPDesktopConfigThumbnails.propTypes = {
  dimensionsImage: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  shouldShowDimensionThumbnail: PropTypes.bool,
  dimensionShotUrls: PropTypes.arrayOf(PropTypes.object),
  enableCrops: PropTypes.bool,
  pdpIsModularBYOProduct: PropTypes.bool,
  isConfigFlipped: PropTypes.bool,
  isCylindoConfigurationPhotos: PropTypes.bool,
  loading: PropTypes.bool,
  photos: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    src: PropTypes.string.isRequired
  })),
  selectedPhoto: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  setSelectedPhoto: PropTypes.func,
  viewGalleryImageEvent: PropTypes.func
};
export default PDPDesktopConfigThumbnails;
function _temp(idx) {
  return <PDPDesktopHeroThumbnail key={idx} loading={true} />;
}